import React from 'react';
import './main.less';

function ContentBody({ children }) {
	return (
		<div className='page-container--content-body'>{children}</div>
	);
}

export default ContentBody;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/page-container/components/content-body/main.js